import { useRef, useState, useEffect } from "react";
import { Modal, Button, SelectPicker } from "rsuite";

interface LineOfBusinessModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: ({
    selectedValue,
    selectedLabel,
    selectedInd,
  }: {
    selectedValue: string;
    selectedLabel: string;
    selectedInd: number | null;
  }) => void;
  dropdownData: { value: string; label: string; selectedInd: number }[];
}

const LineOfBusinessModal: React.FC<LineOfBusinessModalProps> = ({
  open,
  onClose,
  onSubmit,
  dropdownData
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [selectedItem, setSelectedItem] = useState<{
    value: string | null;
    label: string | null;
    selectedInd: number | null;
  }>({ value: null, label: null, selectedInd: null });

  // Create formatted data with unique values (using label as the unique identifier)
  const formattedData = dropdownData.map(item => ({
    label: item.label,
    value: item.label // Use label as value (unique identifier)
  }));

  // Pre-select active item if available
  useEffect(() => {
    const selectedOption = dropdownData.find(item => item.value === "1");
    if (selectedOption) {
      setSelectedItem({
        value: selectedOption.label, // Use label as value
        label: selectedOption.label,
        selectedInd: 1
      });
    }
  }, [dropdownData]);

  const handleSelection = (value: string | null) => {
    if (value) {
      // Find the matching item using the label
      const selected = dropdownData.find(item => item.label === value);
      if (selected) {
        setSelectedItem({
          value: value, // This is the label (unique identifier)
          label: value, // This is also the label
          selectedInd: 1 // Always set to 1 for selected items
        });
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      className="w-[35%]"
      style={{ overflow: "visible" }}
    >
      <Modal.Header>
        <Modal.Title className="mb-5 chart-title font-semibold">
          Demand Brain line of Business
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ position: "relative", overflow: "visible" }} ref={containerRef}>
        <p className="chart-subtitle font-semibold mb-2">
          Please select the line of business
        </p>
        <div>
          <SelectPicker
            data={formattedData}
            value={selectedItem.value}
            placement="bottomStart"
            cleanable={false}
            onChange={handleSelection}
            searchable={false}
            size="sm"
            style={{ width: 200 }}
            container={() => containerRef.current!}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={() =>
            onSubmit({
              selectedValue: "1", // Always send "1" as the value to mark as selected
              selectedLabel: selectedItem.label!, // Send the selected label to identify the item
              selectedInd: 1 // Always send 1 for selected items
            })
          }
          disabled={!selectedItem.value || !selectedItem.label}
          className="bg-deloitteGreen text-white px-[20px] h-[4vh] rounded font-semibold btn-text"
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LineOfBusinessModal;
